import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { HeaderInterceptInterceptor } from './shared/Interceptor/header-intercept.interceptor';
import { CognitoHeaderInterceptor } from './shared/Interceptor/cognito-header.interceptor';
import { configureAmplify } from './config/amplify.config';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MatPaginatorModule,
        MatSortModule,
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [
                    `${environment.apiUrlBase()}/`,
                    "https://auth.dev.medmio.com",
                ],
                sendAccessToken: true,
            },
        }),

        SharedModule,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: configureAmplify,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HeaderInterceptInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CognitoHeaderInterceptor,
            multi: true,
        },
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: { duration: 5000 },
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
